import "./style.css";
const HoverLinks = ({ text, cursor }) => {
  return (
    <div className="hover-link" data-cursor={cursor === false ? "disable" : undefined}>
      <div className="hover-in">
        {text} <div>{text}</div>
      </div>
    </div>
  );
};

export default HoverLinks;
